import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { graphql, gql, compose } from 'react-apollo';

import { Tabs, Tab } from 'material-ui/Tabs';

import Loader from '../../UI/Loader';
import ParticipantsTable from '../ParticipantsTable';
import RegListForm from '../RegListForm';

import styles from './RegListAdmin.css';

const regListQuery = gql`
    query RegListQuery($regListId: ID!) {
        regList(_id: $regListId) {
            _id
            townName
            population
            orgHeadName
            address
            addressee
            orgHeadPosition
            juryHeadName
            juryHeadPosition
            email
            phone
            invitations
            pDate
            mDate
            tDate
            vDate
            pPapersNumber
            mPapersNumber
            tPapersNumber
            vPapersNumber
            participantsNumber
            sentPPapersNumber
            sentMPapersNumber
            sentTPapersNumber
            sentVPapersNumber
            sentParticipantsNumber
            payment
            paymentData
            rulesAreFollowed
            ruleBreakersList
            comments
            lastGrade
            season
            participantDrafts {
                _id
                name
                gender
                grade
                school
                email
                paperDrafts {
                    _id
                    round
                    filename
                    file
                    pages
                }
            }
        }
    }
`;

class RegListAdmin extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
            regList: PropTypes.object,
        }).isRequired,
    };

    render() {
        const {
            intl: { formatMessage },
            data: { regList, loading },
        } = this.props;

        if (loading) {
            return <Loader centerX />;
        }

        if (!regList) {
            return (
                <h2>
                    <FormattedMessage id="RegListAdmin.No such reglist" />
                </h2>
            );
        }

        return (
            <Fragment>
                <h2>{regList.townName}</h2>
                <Tabs tabItemContainerStyle={{ background: 'transparent' }}>
                    <Tab
                        label={formatMessage({ id: 'RegListAdmin.town info' })}
                        style={{ color: 'rbga(0, 0, 0, 0.87)' }}
                    >
                        <RegListForm regList={regList} editable={false} season={regList.season} />
                    </Tab>
                    <Tab
                        label={`${formatMessage({ id: 'RegListAdmin.participants list' })} (${
                            regList.participantDrafts.length
                        })`}
                        style={{ color: 'rbga(0, 0, 0, 0.87)' }}
                    >
                        {regList.participantDrafts.length ? (
                            <ParticipantsTable participants={regList.participantDrafts} season={regList.season} />
                        ) : (
                            <div className={styles.noParticipants}>
                                <FormattedMessage id="RegListAdmin.no participants" />
                            </div>
                        )}
                    </Tab>
                </Tabs>
            </Fragment>
        );
    }
}

export default compose(
    graphql(regListQuery, { options: ({ match }) => ({ variables: { regListId: match.params.id } }) }),
    injectIntl
)(RegListAdmin);



// WEBPACK FOOTER //
// ./src/Components/RegListAdmin/RegListAdmin.js